import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GATracker />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

function GATracker() {
  const location = useLocation();
  useEffect(() => {
    const w = window as any;
    if (typeof w.gtag === 'function') {
      w.gtag('config', 'G-JJMX627Q2T', { page_path: location.pathname + location.search });
    }
  }, [location]);
  return null;
}
